import React, { useState, useEffect } from 'react';
import { Col, Container, Row } from "react-bootstrap";
import { device } from "../../constants";
import styled from "styled-components";
import {  useTranslation } from 'next-i18next';
import { StaticI18nLink } from '../../components/Link';
import { utilityLinks } from '../../data/contact-info';

const FooterContainer = styled(Container)`
  background-color: transparent !important;
  padding-right: 0;
  padding-left: 0;

  a {
    font-family: Hind Madurai;
  }
`;

const OuterRectangle = styled.div`
  position: relative;
  background: linear-gradient(180deg, #000104 0%, #070a12 100%);

  /* accent seam separating the footer from the page */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1.5px;
    background: linear-gradient(
      90deg,
      transparent 0%,
      #9fe87066 25%,
      #0ae1ff66 50%,
      #7d72ff66 75%,
      transparent 100%
    );
  }
`;

const InnerRectangle = styled.div`

`;

const FooterInfo = styled.div`
  display: flex;
  align-items: center;
  /* margin: 2.78vw 1.78vw; */

  @media (max-width: 991px) {
    flex-direction: column;
    align-items: center;
    padding-left: 24px;
    padding-right: 24px;
    gap: 40px;
    padding: 10.26vw 13.59vw;
  }

  @media (min-width: 992px) {
    padding: 2.77vw 7.78vw;

  }

  .main-row {
    @media (max-width: 991px) {
      gap: 40px 0 0 0;
    }

    @media (min-width: 992px) {
      display: grid;
      grid-template-columns: 10% 90%;
      grid-gap: 0 7.08vw;
      justify-content: left !important;
      align-items: flex-start !important;
    }


    .second-row  {
      @media (max-width: 991px) {
      }

      @media (min-width: 992px) {
        width: 100%;
        gap: 7.08vw;
        justify-content: left !important;
      }
    }
  }

  .custom-margin-col {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    @media (max-width: 991px) {
      width: 61.34vw;
      padding: 0 !important;
      margin-top: 40px;
    }

    @media (min-width: 992px) {
      width: auto;
      padding: 0 !important;
    }


    .justify-content-center {
        @media (max-width: 991px) {
          gap: 10.26vw;
        }

        .links-col {
          @media (max-width: 991px) {
            display: flex;      
            gap: 4.10vw;
            flex-direction: column;
            align-items: center;
          }

          @media (min-width: 992px) {
            gap: 1.39vw 0;
            display: flex !important;
            flex-direction: column;
            padding: 0;
            margin: 0;
            max-width: 15vw;
          }
        }

        .address-col {
          @media (max-width: 991px) {
            font-size: 3.07vw;
          }

          @media (min-width: 992px) {
            max-width: 22.23vw !important;
            padding: 0 !important;
            margin: 0 !important;
          }
        }

        .social-networks-col {
          @media (min-width: 992px) {
            padding: 0;
            margin: 0;
            max-width: 8.89vw;
          }
        }

        .gptw-container {
          padding: 0;
          margin: 0;
          align-items: flex-start !important;
          width: 0px;
        }
      }

  }
`;

const LogoCol = styled(Col)`
  text-align: left;

  @media (max-width: 991px) {
    display: ${({ $hideLogo }) => ($hideLogo ? 'none' : 'block')};
    text-align: center;
  }

  @media (min-width: 992px) {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 !important;
    margin: 0 !important;
    width: 6.67vw !important;
  }

  img {
    @media (max-width: 991px) {
      width: 41.02vw;
      height: 10.25vw ;
    }

    @media (min-width: 992px) {
      width: 6.67vw;
      height: 6.67vw;
    }
  }
`;


const LineAboveCopyright = styled.div`
  width: 90%;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.14) 50%,
    transparent 100%
  );
  margin: 0 auto;
`;

const CopyrightContainer = styled.div`
  background-color: #02030a;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;

`;

const CopyrightText = styled.p`
  font-family: Hind Madurai;
  font-size: 1rem;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: center;
  color: #A3A6A6;
  margin: 0;

  @media (max-width: 991px) {
    font-size: 0.75rem;
  }
`;

const FooterLink = styled.a`
  text-decoration: none;
  line-height: 18px;
  font-weight: 400;
  font-size: 3.07vw;
  color: #fff;

  transition: color 0.2s ease;

  @media ${device.laptop} {
    line-height: 120%;
    font-size: 1rem;
    margin-bottom: 20px;

    &:hover {
      text-decoration-line: underline;
      color: #9fe870;
    }
  }

  @media (min-width: 992px) {
    padding: 0 !important;
    margin: 0 !important;
  }
`;

const FooterContent = styled.div`
  margin-bottom: 0px;
  @media (max-width: 991px) {
    text-align: center;
    width: 100%;
    padding: 0 !important;
  }
  
  .partner-col {
    @media (max-width: 991px) {
      margin: 0;
      padding: 0;
    }
  }

  .partner-title {
    @media (max-width: 991px) {
      margin: 0;
      padding: 0;
    }
  }

  .partner-icons {
    @media (max-width: 991px) {
      margin: 0;
      padding: 0;
      min-width: 290px;
    }
  }
`;

const PartnerLogos = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-left: 0;
  width: 100%;
  margin-bottom: 0px;


  img:last-child {
    margin-right: 0; 
  }

  @media (max-width: 991px) {
    gap: 14px 18px;

    justify-content: center;

    /* the "Small" SVGs carry no size constraint and render oversized on the
       narrow layout; normalize them to a compact, even logo height */
    img {
      height: 26px;
      width: auto;
      max-width: 30vw;
    }
  }

  @media (min-width: 992px) {
    img {
      margin-right: 16px;
      margin-bottom: 14px;
    }
  }
`;
const PartnerLabel = styled.p`
  font-family: Hind Madurai;
  font-size: 1rem;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.1em;
  text-align: left;
  color: #FFFFFF;
  max-width: 17%;
  margin-bottom: 8px;

  @media (max-width: 991px) {
    text-align: center;
    max-width: 100%;
    margin-bottom: 4.10vw;
    font-size: 3.07vw;
  
  }
`;

const ContainerAddress = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;

  @media (max-width: 991px) {
    text-align: center;
    align-items: center;
    gap: 2.052vw;
  }

  @media (min-width: 992px) {
    gap: .55vw !important;
  }

  a {
    @media (min-width: 992px) {
      font-size: 1.25vw !important;
      margin-bottom: 0px;
    }
  }
`;

const SocialNetworksContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
  

  h4 {
    font-family: Hind Madurai;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.1em;
    text-align: end !important;
    color: #FFFFFF;
    margin-bottom: 1.67vw;

    @media (max-width: 991px) {
      margin-bottom: 0 !important;
      font-size: 3.07vw;
    }

    @media (min-width: 992px) {
      font-size: 1.11vw;
      text-align: center !important;
    }
  }

  @media (max-width: 991px) {
    align-items: center !important;
    justify-content: center !important; 
    gap: 4.10vw 0;
  }

  @media (min-width: 992px) {
    align-items: center !important;
    justify-content: center !important; 
  }

  .social-icons {
    display: flex;
    align-items: end !important;

    @media (max-width: 991px) {
      justify-content: center !important;    
      margin: 0 !important;
      gap: 0 4.1025vw;
    }

    a {
      margin-right: 2px !important;
      margin-left: 32px !important;
      &:nth-last-child(1) {
        margin-right: 0;
      }
    }
  }

  .social-icons {
    display: flex;
    align-items: center;
    margin-left: -36px;

    a {
      margin-right: 26px ;
      margin-left: 0px;
    }

    @media (max-width: 991px) {
      a {
        margin: 0 !important;
       }
  }
}`;

const AddressContainer = styled.div`
  a {
    font-family: Hind Madurai;

    @media (max-width: 991px) {
      font-size: 3.07vw;
    }
  }

  h4 {
    font-family: Hind Madurai;

    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.1em;
    text-align: left;
    color: #FFFFFF;

    @media (max-width: 991px) {
      font-size: 3.07vw;
      margin-bottom: 2.052vw;
    }

    @media (min-width: 992px) {
      margin-bottom: 1.11vw;
      font-size: 1.11vw;
    }
  }

  ${FooterLink} {
    color: #FFFFFF;
  }


  @media (max-width: 991px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

const FooterLinkContainer = styled.div`
  text-align: center; 

  @media (max-width: 991px) {
    padding: 0 !important;
  }

  @media (min-width: 992px) {
    text-align: left; 
  }

  a {
    @media (min-width: 992px) {
      font-size: 0.98vw;
    }
  }
`;

export function Footer() {
  const { t } = useTranslation();
  const [windowWidth, setWindowWidth] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    setWindowWidth(window.innerWidth);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    <OuterRectangle>
      <FooterContainer fluid>
        <InnerRectangle>
          <FooterInfo>
            <Row className="w-100 align-items-center justify-content-center main-row">
              <LogoCol xs={12} lg={2} $hideLogo={false}>
                <img src={windowWidth < 992 ? "/landings/assets/images/logo_icon_verzel_white.svg" : "/landings/assets/images/LogoVerzelHorizontal.svg"} alt={windowWidth < 992 ? "Logo Verzel" : "Lofo Verzel Horizontal"} style={{ width: "163px" }} />
              </LogoCol>

              <Col xs={8} lg={9} className="custom-margin-col">
                <Row className="justify-content-center second-row">


                  {/* Links */}
                  <Col xs={12} md={12} lg={4} className="links-col">
                    <FooterLinkContainer>
                      <StaticI18nLink href="/cases/1">
                        <FooterLink style={{ textDecoration: "underline", display: "flex", height: "16px" }}>
                          {t("footer.customerCases")}
                        </FooterLink>
                      </StaticI18nLink>
                    </FooterLinkContainer>
                    <FooterLinkContainer>
                      <StaticI18nLink href="/blog">
                        <FooterLink style={{ textDecoration: "underline", display: "flex", height: "16px" }}>
                          {t("footer.latestNews")}
                        </FooterLink>
                      </StaticI18nLink>
                    </FooterLinkContainer>
                    <FooterLinkContainer>
                      <FooterLink href={utilityLinks.workWithUs} target="_blank" rel="noreferrer noopener" style={{ textDecoration: "underline", display: "flex", height: "16px" }}>
                        {t("footer.joinOurTeam")}
                      </FooterLink>
                    </FooterLinkContainer>
                    <FooterLinkContainer>
                      <StaticI18nLink href="/privacy-policy">
                        <FooterLink style={{ textDecoration: "underline", display: "flex", height: "16px" }}>
                          {t("footer.privacyPolicy")}
                        </FooterLink>
                      </StaticI18nLink>
                    </FooterLinkContainer>
                  </Col>

                  {/* Address */}
                  <Col xs={12} md={12} lg={5} style={{ paddingLeft: "5px" }} className="address-col">
                    <AddressContainer>
                      <h4>{t("footer.address")}</h4>
                      <ContainerAddress>
                        <span className='text-white'>
                          Rua Aníbal Benévolo, 94 - 2° Andar <br />
                        </span>
                        <span className='text-white'>
                          Santana - São Paulo/SP - CEP 02016-040
                        </span>
                      </ContainerAddress>
                    </AddressContainer>
                  </Col>

                  {/* Social Media */}
                  <Col xs={12} md={12} lg={3} className="social-networks-col">
                    <SocialNetworksContainer>
                      <h4>{t("footer.socialNetworks")}</h4>
                      <div className="social-icons">
                        <FooterLink href="https://www.instagram.com/verzel.tech/" >
                          <img src="/landings/assets/images/ri_instagram-fill.svg" alt="Instagram" style={{ width: `${windowWidth < 992 ? "8.205vw" : "3.34vw"}`, height: `${windowWidth < 992 ? "8.205vw" : "3.34vw"}` }}/>
                        </FooterLink>
                        <FooterLink href="https://www.linkedin.com/company/verzeloficial/mycompany/">
                          <img src="/landings/assets/images/mdi_linkedin.svg" alt="LinkedIn" style={{ width: `${windowWidth < 992 ? "8.205vw" : "3.34vw"}`, height: `${windowWidth < 992 ? "8.205vw" : "3.34vw"}` }}/>
                        </FooterLink>
                      </div>
                    </SocialNetworksContainer>
                  </Col>

                  {/* GPTW */}
                  <Col xs={1} className="d-flex align-items-end justify-content-center gptw-container">
                    <LogoCol xs={2} $hideLogo={true}>
                      <img src="/landings/assets/images/GPTWHorizontal.svg" alt="GPTW Horizontal" style={{ width: "4.17vw", height: "6.67vw" }} />
                    </LogoCol>
                  </Col>
                </Row>
              </Col>

              {/* Partners - Mobile */}
              {windowWidth < 992 && (
                <FooterContent>
                  <Row className="w-100 justify-content-center align-items-center">
                    <Col xs={12} md={12} lg={2} className="text-center partner-title"> 
                      <PartnerLabel>{t("footer.partners")}</PartnerLabel>
                    </Col>
                    <Col xs={12} md={12} lg={10} className="partner-icons">
                      <PartnerLogos>
                        {windowWidth < 992 ? (
                          <>
                            <img src="/landings/assets/images/LogoDevariaSmall.svg" alt="Devaria" />
                            <img src="/landings/assets/images/GrupoPRIMOSmall.svg" alt="GrupoPrimo" />
                            <img src="/landings/assets/images/EnkelSmall.svg" alt="Enkel" />
                            <img src="/landings/assets/images/AWSSmall.svg" alt="AWS" />
                            <img src="/landings/assets/images/DocuSignSmall.svg" alt="DocuSigns" />
                          </>
                        ) : (
                          <>
                            <img src="/landings/assets/images/LogoDevaria.svg" alt="Devaria" />
                            <img src="/landings/assets/images/GrupoPRIMO.svg" alt="GrupoPrimo" />
                            <img src="/landings/assets/images/Enkel.svg" alt="Enkel" />
                            <img src="/landings/assets/images/AWS.svg" alt="AWS" />
                            <img src="/landings/assets/images/DocuSign.svg" alt="DocuSigns" />
                          </>
                        )}
                      </PartnerLogos>
                    </Col>
                  </Row>
                </FooterContent>
              )}

            </Row>
          </FooterInfo>
          <LineAboveCopyright />
        </InnerRectangle>
        <CopyrightContainer>
          <CopyrightText>
            {`© ${new Date().getFullYear()} ${t("footer.copyright")}`}
          </CopyrightText>
        </CopyrightContainer>
      </FooterContainer>
    </OuterRectangle>
  );

}
